import { useEffect, useState } from 'react';
import { Promotion } from 'Services/Mongo/Types';
import { Product } from '@setvi/shared/interfaces';
import { useQuery } from '@tanstack/react-query';
import { getPromotionsQuery } from '@setvi/shared/services';

interface usePromotionDetailsProps {
  product: Product;
}

export const usePromotionDetails = ({ product }: usePromotionDetailsProps) => {
  const [initLoading, setInitLoading] = useState(true);
  const [activePromotion, setActivePromotion] = useState<Promotion | null>(
    null
  );

  const { data, isLoading, isFetching } = useQuery({
    ...getPromotionsQuery({
      skus: product?.promotions
    }),
    enabled: product?.promotions?.length > 0
  });

  useEffect(() => {
    if (data) {
      data?.total === 1 && setActivePromotion(data?.data?.[0]);
      setInitLoading(false);
    }
  }, [data]);

  return {
    promotions: data?.data || [],
    activePromotion,
    loading: isLoading || isFetching || initLoading,
    setActivePromotion
  };
};
